







































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { usersCollection } from "../../db";

@Component({})
export default class EquipmentCategories extends Vue {
  @Getter users;

  private search = "";
  private dialog = false;
  private formEditMode = false;
  private form = {
    id: undefined,
    email: "",
    photoURL: "",
    displayName: "",
    admin: false,
  };

  private headers = [
    { text: "Edit", value: "edit", sortable: false },
    { text: "Name", value: "displayName" },
    { text: "Email", value: "email" },
    { text: "Photo", value: "photoURL" },
    { text: "Delete", value: "delete", sortable: false },
  ];

  edit(item) {
    this.form = {
      id: item.id,
      email: item.email,
      photoURL: item.photoURL,
      displayName: item.displayName,
      admin: item.admin,
    };
    this.formEditMode = true;
    this.dialog = true;
  }

  async save() {
    await usersCollection.doc(`${this.form.id}`).update({
      admin: this.form.admin,
    });
    this.dialog = false;
    this.formEditMode = false;
    this.clearForm();
  }

  async remove(item) {
    await usersCollection.doc(`${item.id}`).delete();
  }

  close() {
    this.dialog = false;
    this.clearForm();
  }

  clearForm() {
    this.form = {
      id: undefined,
      email: "",
      photoURL: "",
      displayName: "",
      admin: false,
    };
  }
}
